import React from 'react';

export const ArrowBack = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path stroke="#72706F" strokeLinecap="round" strokeLinejoin="round" d="M14.4 7.2 9.6 12l4.8 4.8" />
      </g>
    </svg>
  );
};

export default ArrowBack;
